// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5813a003","239":"d2407c2d","453":"dce8c795","732":"f748f5cd"}[chunkId] + ".chunk.js";
};